<template>
    <div class="steps">
        <div v-if="step === 1"
             class="card step">
            <h4 class="card-header bg-dark text-white">Step 1</h4>
            <div class="card-body">
                <h4 class="card-title">Sign in</h4>
                <p class="card-text">Fast and convenient way for people to create accounts and log into our system across multiple platforms</p>
                <div v-if="!signedin">

                    <button class="btn btn-primary btn-margin"
                            @click="login('facebook')">Sign in with Facebook</button>

                    <button class="btn btn-danger btn-margin"
                            @click="login('google')">Sign in with Google</button>

                    <small class="form-text text-muted">By create account, you are agreeing to the Terms of Service and the Privacy Policy.</small>
                </div>
                <div v-else-if="signedin">
                    <button class="btn btn-secondary btn-margin"
                            @click="logout">Sign out</button>
                    <button class="btn btn-dark btn-margin"
                            @click="step++">Continue</button>
                    <small class="form-text text-muted">Signed in as {{ name }}</small>
                </div>
            </div>
        </div>

        <div v-if="step === 2"
             class="card step">
            <h4 class="card-header bg-dark text-white">Step 2</h4>
            <div class="card-body">
                <h4 class="card-title">Update your email address</h4>
                <p class="card-text">We will contact you via this email</p>
                <div class="form-group">
                    <input v-model="email"
                           type="email"
                           class="form-control"
                           placeholder="Enter email">
                </div>
                <button class="btn btn-secondary btn-margin"
                        @click="step--">Back</button>
                <button class="btn btn-dark btn-margin"
                        @click="updateEmail">Continue</button>
                <small class="form-text text-muted">We'll never share your email with anyone else.</small>
            </div>
        </div>

        <div v-show="step === 3"
             class="card step">
            <h4 class="card-header bg-dark text-white">Step 3</h4>
            <div class="card-body">
                <h4 class="card-title">Enter your billing details</h4>
                <p class="card-text">Credit or Debit card</p>

                <div id="stripe_card" />
                <small v-if="card_err !== ''"
                       class="form-text text-danger">{{ card_err }}</small>

                <button :disabled="paying"
                        class="btn btn-secondary btn-margin"
                        @click="step--">Back</button>
                <button :disabled="paying"
                        class="btn btn-dark btn-margin"
                        @click="createCardToken">Complete</button>
                <small v-if="paying"
                       class="form-text text-muted">Please wait up to a min...</small>
            </div>
        </div>
    </div>
</template>

<script>
import {
    config,
    auth,
    gateway,
    response,
    popup,
    handler,
    aw,
} from 'website-core'

export default {
    data() {
        return {
            email: '',
            name: '',
            step: 1,
            signedin: false,

            cardSelector: '#stripe_card',
            card_err: '',
            card: null,

            paying: false,
        }
    },
    async mounted() {
        await auth.init()
        gateway.stripe.init()
        this.card = gateway.stripe.initCard(this.cardSelector)

        // stripe card error
        // real time validation
        this.card.addEventListener('change', this.onCardErr)
    },
    methods: {
        async handleLoggedIn(user, auth_type) {
            if (!user) {
                popup.showErr(
                    'There was an error with your login. Please try again later'
                )
                return
            }

            // check existing customer
            try {
                const exist = await aw.customer.exist(auth_type)
                auth.saveSession(auth_type)

                if (exist) {
                    const ok = await popup.showConfirm(
                        'Seems like you already signed up',
                        'Wanna sign in instead?',
                        'warning'
                    )
                    if (ok) {
                        window.location =
                            config.url_dashboard + '/' + auth.getSession()
                        return
                    }

                    this.logout()
                    return
                }

                // ok
                this.email = user.email
                this.name = user.name
                this.signedin = true
            } catch (err) {
                handler(err)
            }
        },
        async login(type) {
            const user = await auth.login(type)
            this.handleLoggedIn(user, type)
            return
        },
        async logout() {
            await auth.logout()

            this.email = ''
            this.name = ''
            this.signedin = false
        },
        updateEmail() {
            // upl allows same email for multiple customers
            this.step = 3
        },
        async createCardToken() {
            if (this.card_err !== '') {
                return
            }

            // verify plan
            if (!this.$route.params['plan']) {
                response.ResShowErr('Invalid Plan')
                return
            }

            this.paying = true
            const { token, err } = await gateway.stripe.createCardToken(
                this.card
            )
            if (err) {
                this.paying = false
                response.ResShowErr(err)
                return
            }

            this.checkout(token)
        },
        async checkout(card_token) {
            this.paying = true

            try {
                await aw.customer.create({
                    email: this.email,
                    name: this.name,
                    plan: this.$route.params['plan'],
                    card_token: card_token,
                })

                // ok
                auth.saveSession()
                await popup.showConfirm(
                    'Thank you!',
                    "Let's get started",
                    'success',
                    'Go to Dashboard'
                )
                window.location = config.url_dashboard + '/' + auth.getSession()
            } catch (err) {
                handler(err)
            } finally {
                this.paying = false
            }
        },
        onCardErr(event) {
            this.card_err = ''

            if (event.error) {
                this.card_err = event.error.message
            }
        },
    },
}
</script>

<style scoped>
.steps {
    margin: 2rem 0;
}
.step {
    margin: 0.5rem 0;
}

#stripe_card {
    margin: 1rem 0;
}

.btn-margin {
    margin-top: 0.5rem;
    margin-left: 0.5rem;
}

.StripeElement {
    background-color: white;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
}

.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}
</style>
